import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './genericModal.component.html',
    standalone: false
})

export class GenericModalComponent {

  constructor(public dialogRef: MatDialogRef<GenericModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  confirm() {
    this.dialogRef.close({ confirm: true });
  }
  closeModal() {
    this.dialogRef.close();
  }
}
